var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.compToLoad,{tag:"component",staticClass:"pa-0 ma-0",attrs:{"id":"dashboard_root"}})
}
var staticRenderFns = []

export { render, staticRenderFns }